import { EVENT } from "@/constant/global";
import { useEventBus } from "@vueuse/core";
import { defineStore } from "pinia";

interface OnceState {
    /**
     * 判断 OCC 是否授权成功
     */
    hasCheckOccAuth: boolean,
    /**
     * 是否获取视频授权
     */
    hasVideoAuth: boolean,
    /**
     * 用于判断是否识别成功，若识别成功想要重新进识别流程的话需要重置流程
     */
    hasSuccessRecognize: boolean,
}

export const useOnceStore = defineStore({
    id: 'app-once',
    persist: false,
    state: (): OnceState => ({
        hasCheckOccAuth: false,
        hasVideoAuth: false,
        hasSuccessRecognize: false,
    }),
    actions: {
        exciteHasCheckOccAuth() {
            this.hasCheckOccAuth = true;
            useEventBus(EVENT.SET_OCC_TOKEN_SUCCESS).emit();
        },
        exciteHasVideoAuth() {
            this.hasVideoAuth = true;
        },
        setHasSuccessRecognize(value: boolean) {
            this.hasSuccessRecognize = value;
        }
    },
})